<template>
  <b-row>
    <b-col cols="12" class="mt-1">
      <div class="d-flex justify-content-end">
        <b-button variant="primary" v-b-modal.modal-main class="my-1">
          Add Supplier
        </b-button>
      </div>

      <b-modal id="modal-main" cancel-variant="outline-secondary" centered title="Add Supplier" hide-footer>
        <validation-observer ref="AddSupplierForm" @submit.prevent="validationForm">
          <b-form @submit.prevent>
            <b-form-group>
              <label for="email">Supplier Name:*</label>
              <validation-provider v-slot="{ errors }" name="name" vid="name" rules="supplier_name">
                <b-form-input id="name" type="text" placeholder="Supplier Name" v-model="name" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group>
              <label for="email">Email:*</label>
              <validation-provider :rules="{ required: true, email_message: true }" v-slot="{ errors }" name="email" vid="email" >
                <b-form-input id="email" type="email" placeholder="Email Address" v-model="email"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group>
              <label for="email">Address:</label>
              <validation-provider #default="{ errors }" name="Address" vid="Address">
                <b-form-input id="address" type="text" placeholder="Address" v-model="address" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group>
              <label for="email">Phone Number:</label>
              <validation-provider :rules="{phone:true}" v-slot="{ errors }" name="Phone" vid="Phone">
                <b-form-input id="phoneNumber" type="text" placeholder="Phone number" v-model="phoneNumber" @keypress="allowOnlyNumbers($event)" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group>
              <label for="email">Goods Supplied:</label>
              <validation-provider #default="{ errors }" name="Goods" vid="Goods">
                <b-form-input id="goodsSupplied" type="text" placeholder="Goods Supplied" v-model="goodsSupplied" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group>
              <label for="email">Contact Person:</label>
              <validation-provider #default="{ errors }" name="Contact" vid="Contact">
                <b-form-input id="contactPerson" type="text" placeholder="Contact Person" v-model="contactPerson" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group>
              <label for="brn">BRN:</label>
              <validation-provider #default="{ errors }" name="BRN" vid="BRN">
                <b-form-input id="brn" type="text" placeholder="Business Registration Number" v-model="brn" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group>
              <label for="vatNumber">VAT No:</label>
              <validation-provider #default="{ errors }" name="VAT No" vid="VAT No">
                <b-form-input id="vatNumber" type="text" placeholder="VAT Number" v-model="vatNumber" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group>
              <label for="reference">Reference:</label>
              <validation-provider #default="{ errors }" name="Supplier Reference" vid="Supplier Reference">
                <b-form-input id="reference" type="text" placeholder="Reference" v-model="reference" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <CustomFieldsDetails :AdditionalFields="additionalFields" :ModuleReference="'Supplier'"
              @onchange="additionalFieldChanges"></CustomFieldsDetails>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" @click="AddSupplier()">
                <b-spinner small v-if="loading" class="mx-2" />Add
              </button>
            </div>
          </b-form>
        </validation-observer>
      </b-modal>

      <b-modal id="modal-edit" cancel-variant="outline-secondary" ok-title="Edit" cancel-title="Close" centered
        title="Edit Supplier" hide-footer @hidden="reloadPage()"   @cancel="resetEditForm"
  @close="resetEditForm" >
        <validation-observer ref="EditSupplierForm" #default="{ invalid }">
          <b-form @submit.prevent>
            <b-form-group>
              <label for="email">Supplier Name:*</label>
              <validation-provider #default="{ errors }" name="name" vid="name" rules="required">
                <b-form-input id="name" type="text" placeholder="Supplier Name" v-model="supplierData.name" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group>
              <label for="email">Email:</label>
              <validation-provider rules="email" #default="{ errors }" rule name="email" vid="email">
                <b-form-input id="email" type="email" placeholder="Email Address" :value="supplierData.email"
                  v-model="supplierData.email" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group>
              <label for="email">Address:</label>
              <validation-provider #default="{ errors }" name="Address" vid="Address">
                <b-form-input id="address" type="text" placeholder="John Doe" v-model="supplierData.address" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group>
              <label for="email">Phone Number:</label>
              <validation-provider #default="{ errors }" name="Phone" vid="Phone">
                <b-form-input id="phoneNumber" type="number" placeholder="Phone number"
                  v-model="supplierData.phoneNumber" @keypress="allowOnlyNumbers($event)"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group>
              <label for="email">Goods Supplied:</label>
              <validation-provider #default="{ errors }" name="Goods" vid="Goods">
                <b-form-input id="goodsSupplied" type="text" placeholder="Goods Supplied"
                  v-model="supplierData.goodsSupplied" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group>
              <label for="email">Contact Person:</label>
              <validation-provider #default="{ errors }" name="Contact" vid="Contact">
                <b-form-input id="contactPerson" type="text" placeholder="Contact Person"
                  v-model="supplierData.contactPerson" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group>
              <label for="brn">BRN:</label>
              <validation-provider #default="{ errors }" name="BRN" vid="BRN">
                <b-form-input id="brn" type="text" placeholder="Business Registration Number" v-model="supplierData.brn" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group>
              <label for="vatNumber">VAT No:</label>
              <validation-provider #default="{ errors }" name="VAT No" vid="VAT No">
                <b-form-input id="vatNumber" type="text" placeholder="VAT Number" v-model="supplierData.vatNumber" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group>
              <label for="reference">Reference:</label>
              <validation-provider #default="{ errors }" name="Supplier Reference" vid="Supplier Reference">
                <b-form-input id="reference" type="text" placeholder="Reference" v-model="supplierData.reference" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-col cols="12">
              <CustomFieldsDetails :AdditionalFields="supplierData.additionalFields" :ModuleReference="'Supplier'"
                @onchange="additionalFieldChangesEdit" />
            </b-col>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" block :disabled="invalid" @click="EditSupplier()">
                <b-spinner small v-if="loading" class="mx-2" />Edit
              </button>
            </div>
          </b-form>
        </validation-observer>
      </b-modal>
    </b-col>
    <b-col  cols="12" md="2" sm="2" class="my-1">
      <b-form-group class="mb-0">
        <label class="d-inline-block text-sm-left mr-50">Per page</label>
        <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" />
      </b-form-group>
    </b-col>
    <b-col md="4" sm="8"> </b-col>

    <b-col cols="12" class="d-flex justify-content-end mb-2" style="position: relative; z-index: 1;">
      <b-button variant="outline-danger" @click="clearFilters">
        Clear Filters
      </b-button>
    </b-col>

    <b-col cols="12">
      <b-table striped hover responsive :per-page="perPage" :current-page="currentPage" :items="filteredSuppliers"
        :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
        @filtered="onFiltered">
        <!-- Filter inputs for each column -->
        <template #head(name)>
          <div>
            <span>Name</span>
            <b-form-input v-model="filters.name" placeholder="Filter by Name" size="sm"
              @input="applyFilter"></b-form-input>
          </div>
        </template>
        <template #head(email)>
          <div>
            <span>Email</span>
            <b-form-input v-model="filters.email" placeholder="Filter by Email" size="sm"
              @input="applyFilter"></b-form-input>
          </div>
        </template>
        <template #head(address)>
          <div>
            <span>Address</span>
            <b-form-input v-model="filters.address" placeholder="Filter by Address" size="sm"
              @input="applyFilter"></b-form-input>
          </div>
        </template>
        <template #head(phoneNumber)>
          <div>
            <span>Phone Number</span>
            <b-form-input v-model="filters.phoneNumber" placeholder="Filter by Phone" size="sm"
              @input="applyFilter"></b-form-input>
          </div>
        </template>
        <template #head(goodsSupplied)>
          <div>
            <span>Goods Supplied</span>
            <b-form-input v-model="filters.goodsSupplied" placeholder="Filter by Goods Supplied" size="sm"
              @input="applyFilter"></b-form-input>
          </div>
        </template>
        <template #head(contactPerson)>
          <div>
            <span>Contact Person</span>
            <b-form-input v-model="filters.contactPerson" placeholder="Filter by Contact Person" size="sm"
              @input="applyFilter"></b-form-input>
          </div>
        </template>

        <template #cell(avatar)="data">
          <b-avatar :src="data.value" />
        </template>

        <template #cell(status)="data">
          <b-badge :variant="status[1][data.value]">
            {{ status[0][data.value] }}
          </b-badge>
        </template>

        <template #cell(actions)="data">
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template v-slot:button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
            </template>
            <b-dropdown-item v-b-modal.modal-edit @click="getSupplierData(data.item)">
              <feather-icon icon="Edit2Icon" class="mr-50" />
              <span>Edit</span>
            </b-dropdown-item>
            <b-dropdown-item @click="removeSupplier(data.item.id)">
              <feather-icon icon="TrashIcon" class="mr-50" />
              <span>Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>

      <div class="d-flex justify-content-center mb-1">
        <b-spinner variant="success" label="Spinning" block v-if="loading"
          style="width: 3rem; height: 3rem"></b-spinner>
      </div>
    </b-col>

    <b-col cols="12">
      <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center" size="sm"
        class="my-0" />
      <b-form-group>
        Showing 
        {{ totalRows > 0 ? (perPage * (currentPage - 1) + 1) : 0 }} 
        to 
        {{ totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0 }} 
        of 
        {{ totalRows > 0 ? totalRows : 0 }} 
        entries
      </b-form-group>
    </b-col>

    <b-col cols="12"> </b-col>
  </b-row>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BTabs,
  BTab,
  BCardImg,
  BCardFooter,
  BModal,
  BSpinner,
  BDropdown,
  BDropdownItem,
  BForm,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver,extend } from "vee-validate";
import { mapActions, mapGetters } from "vuex";
import { required } from '@validations'
import { customError } from "@/libs/customFn";
import CustomFieldsDetails from "@/views/component/CustomFieldsDetails.vue";
import { email, required as rule_required } from 'vee-validate/dist/rules';

import { filter } from "lodash";
extend('email_message', {
  validate(value) {
    return /^\S+@\S+\.\S+$/.test(value);
  },
  message: 'Please enter a valid email address.'
});
extend('supplier_name', {
  ...rule_required,
  message: 'Supplier name is required.'
});
extend('phone', {
  validate(value) {
      return /^[0-9]{7,15}$/.test(value);
  },
   message: "The {_field_} field must be between 7 and 15 digits"
});
export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BModal,
    BSpinner,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
    BForm,
    CustomFieldsDetails,
    ///////
    required,
  },
  data() {
    return {
      name: "",
      email: "",
      address: "",
      phoneNumber: "",
      goodsSupplied: "",
      contactPerson: "",
      perPage: 5,
      brn: "",
      vatNumber: "",
      reference: "",
      supplierData: [],
      pageOptions: [3, 5, 10],
      totalRows: 0,
      currentPage: 0,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      fields: [
        { key: "name", label: "name", sortable: true },
        { key: "email", label: "email", sortable: true },
        { key: "address", label: "address", sortable: true },
        { key: "phoneNumber", label: "phoneNumber", sortable: true },
        { key: "goodsSupplied", label: "goodsSupplied", sortable: true },
        { key: "contactPerson", label: "contactPerson", sortable: true },
        "Actions",
      ],
      filters: {
        name: "",
        email: "",
        address: "",
        phoneNumber: "",
        goodsSupplied: "",
        contactPerson: "",
      },
      additionalFields: [
        {
          fieldName: null,
          fieldValue: null,
          fieldType: "text",
          isRequired: false,
          displayEcomm: false,
        },
      ],
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    ...mapGetters("supplierModule", {
      supplierList: "suppliers",
      loading: "loading",
    }),
    filteredSuppliers() {
      let supList = this.supplierList.filter((supplier) => {
        return (
          (!this.filters.name || supplier.name.toLowerCase().includes(this.filters.name.toLowerCase())) &&
          (!this.filters.email || supplier.email && supplier.email.toLowerCase().includes(this.filters.email)) &&
          (!this.filters.address || supplier.address && supplier.address.toLowerCase().includes(this.filters.address)) &&
          (!this.filters.phoneNumber || supplier.phoneNumber && supplier.phoneNumber.toLowerCase().includes(this.filters.phoneNumber)) &&
          (!this.filters.goodsSupplied || supplier.goodsSupplied && supplier.goodsSupplied.toLowerCase().includes(this.filters.goodsSupplied)) &&
          (!this.filters.contactPerson || supplier.contactPerson && supplier.contactPerson.toLowerCase().includes(this.filters.contactPerson))
        );
      });
      this.totalRows = supList.length;
      this.currentPage = 1;
      return supList;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
  },
  methods: {
    allowOnlyNumbers(event) {
  const charCode = event.which ? event.which : event.keyCode;

  if (
    charCode < 48 || charCode > 57
  ) {
    event.preventDefault();
  }
},
    ...mapActions("supplierModule", [
      "getSupplierListAction",
      "removeSupplierAction",
      "addSupplierAction",
      "updateSupplierAction",
    ]),

    validateEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.isValidEmail = emailRegex.test(email);
    },

    successEdit() {
      this.$swal({
        title: "Supplier edited!",
        text: "You have successfully edited a supplier!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    additionalFieldChanges(customFields) {
      this.additionalFields = customFields;
    },

    additionalFieldChangesEdit(customFields) {
      this.supplierData.additionalFields = customFields;
    },

    // error
    errorEdit() {
      this.$swal({
        title: "Error!",
        text: " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

 getSupplierData(data) {
  this.originalSupplierData = data; // keep original reference
  this.supplierData = JSON.parse(JSON.stringify(data)); // deep clone
},
resetEditForm() {
  this.supplierData = JSON.parse(JSON.stringify(this.originalSupplierData));
},

    successAdd() {
      this.$swal({
        title: "Supplier Added!",
        text: "You have successfully added a supplier!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    reloadPage() {
      this.getSupplierListAction();
    },
    AddSupplier() {
      this.$refs.AddSupplierForm.validate().then((success) => {
        if (success) {
          let payload = {
            name: this.name,
            email: this.email,
            address: this.address,
            phoneNumber: this.phoneNumber,
            goodsSupplied: this.goodsSupplied,
            contactPerson: this.contactPerson,
            brn: this.brn,
            vatNumber: this.vatNumber,
            reference: this.reference,
            additionalFields: this.additionalFields,
          };
          this.addSupplierAction(payload)
            .then(() => {
              this.successAdd();
              this.resetForm();
              this.$bvModal.hide("modal-main");

               this.getSupplierListAction()
      .then(() => {
        this.totalRows = this.supplierList.length;
      })
      .catch((response) => {
        console.log(response);
      });
            })
            .catch((err) => {
              customError(err.response.data);
              this.resetForm();
              this.$bvModal.hide("modal-main");
            });
        }
      })
    },

    EditSupplier() {
      // let payload = {
      //   name: this.supplierData.name,
      //   email: this.supplierData.email,
      //   address: this.supplierData.address,
      //   phoneNumber: this.supplierData.phoneNumber,
      //   goodsSupplied: this.supplierData.goodsSupplied,
      //   contactPerson: this.supplierData.contactPerson
      // }
      let payload = this.supplierData;
      console.log("🚀 ~ EditSupplier ~ payload:", payload)
      this.updateSupplierAction(payload)
        .then(() => {
          this.successEdit();
          this.$bvModal.hide("modal-edit");
        })
        .catch(() => {
          this.successEdit();
          this.$bvModal.hide("modal-edit");
        });
    },

    resetForm() {
  this.name = "";
  this.email = "";
  this.address = "";
  this.phoneNumber = "";
  this.goodsSupplied = "";
  this.contactPerson = "";
  this.brn = "";
  this.vatNumber = "";
  this.reference = "";
  this.additionalFields = [];
},

    removeSupplier(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.removeSupplierAction(id).then(() => {
            this.$swal({
              title: "Deleted!",
              text: "This supplier has been deleted.",
              icon: "success",
              customClass: {
                confirmButton: "btn btn-success",
              },
            });
          }).catch((error) => {
            this.$swal({
              title: "Error!",
              text: " Failed! " + error.response.data.message,
              icon: "error",
              customClass: {
                confirmButton: "btn btn-primary",
              },
              buttonsStyling: false,
            });
          });

        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Cancelled",
            text: "Supplier is safe :)",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },

    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    applyFilter() {
      this.currentPage = 1; // Reset pagination to the first page when filters are applied
    },
    clearFilters() {
      // Reset all filter values
      this.filters = {
        name: "",
        email: "",
        address: "",
        phoneNumber: "",
        goodsSupplied: "",
        contactPerson: ""
      };
      // Reset pagination
      this.currentPage = 1;
    },
  },
  async mounted() {
    await this.getSupplierListAction()
      .then(() => {
        this.totalRows = this.supplierList.length;
      })
      .catch((response) => {
        console.log(response);
      });
  },
};
</script>
